import React from 'react';
import './selectors.css';

type Exchange = 'binance' | 'mexc';
type Market = 'spot' | 'futures';

interface ExchangeMarketSelectProps {
  exchange: Exchange;
  market: Market;
  onChangeExchange: (e: Exchange) => void;
  onChangeMarket: (m: Market) => void;
}

const EXCHANGES: { value: Exchange; label: string }[] = [
  { value: 'binance', label: 'Binance' },
  { value: 'mexc', label: 'MEXC' },
];

const MARKETS: { value: Market; label: string }[] = [
  { value: 'spot', label: 'Spot' },
  { value: 'futures', label: 'Futures' },
];

/** Two segmented controls: Exchange (Binance/MEXC) and Market (Spot/Futures). */
export function ExchangeMarketSelect({
  exchange,
  market,
  onChangeExchange,
  onChangeMarket,
}: ExchangeMarketSelectProps) {
  return (
    <div className="seg-group">
      <div className="seg">
        {EXCHANGES.map((e) => (
          <button
            key={e.value}
            type="button"
            className={`seg-btn${exchange === e.value ? ' on' : ''}`}
            onClick={() => onChangeExchange(e.value)}
          >
            {e.label}
          </button>
        ))}
      </div>
      <div className="seg">
        {MARKETS.map((m) => (
          <button
            key={m.value}
            type="button"
            className={`seg-btn${market === m.value ? ' on' : ''}`}
            onClick={() => onChangeMarket(m.value)}
          >
            {m.label}
          </button>
        ))}
      </div>
    </div>
  );
}
